import React from 'react';
import axios from 'axios';

import Header from '../components/header';
import IssueSideNav from '../components/issue_sidenav';
import IssueElement from '../components/issue_element';
import Loading from '../components/loading';

import WarningAction from '../components/warning_action';
import ProgressLoader from '../components/progress_loader';

import '../components/css/main.css';
import OnboardingTutorial from '../components/onboarding_editor';

class Issue extends React.Component {
    constructor(props) {
        super(props);
        let initTimeStamp = 0;
        this.state = {
            loading: true,
            step_selection: '1',
            toAdd: {
                type: false,
            },
            certTemplate: "tem0",
            elementsIndex: [],
            variableIndex: [
                {
                    type: "variable",
                    variables: ['[Recepient Name]']
                }
            ],
            toPdf: {
                pdf: false,
                pdfFilename: false,
                pdfSize: false,
            },
            email: "",
            csvData: [],
            updateCsv: 0,
            warning_action: {
                message: "",
                subtext: "",
                type: "warning",
                proceed_action: false,
                proceed_function: false,
                back_action: false,
                close: true,
            },
            elements: [
                {
                    type: 'variable',
                    timeStamp: Date.now() + initTimeStamp++,
                    fontSize: 21,
                    fontFamily: 'Arimo, sans-serif',
                    fontColor: '#000',
                    fontWeight: false,
                    fontStyle: false,
                    textDecorationLine: false,
                    lineHeight: '1',
                    textAlign: 'center',
                    dataType: "textarea",
                    content: "[Recepient Name]",
                    required: true,
                    readOnly: true,
                    placeholder: 'Recepient Name',
                    elHeight: 38,
                    elWidth: 200,
                    x: 275,
                    y: 150,
                    zIndex: 1,
                },
                {
                    type: 'required',
                    timeStamp: Date.now() + initTimeStamp++,
                    fontSize: 24,
                    fontFamily: 'Arimo, sans-serif',
                    fontColor: '#157EFB',
                    fontWeight: false,
                    fontStyle: false,
                    textDecorationLine: false,
                    lineHeight: '1',
                    textAlign: 'center',
                    dataType: "textarea",
                    content: "Certificate of Participation",
                    required: true,
                    readOnly: false,
                    placeholder: 'Certificate Title',
                    elHeight: 41,
                    elWidth: 300,
                    x: 250,
                    y: 100,
                    zIndex: 1,
                },
            ],
            certWidth: 904,
            certHeight: 640,
            generative: false,
            colors: null,
            elementToDelete: false,
            savedTemplates: [],
            saveListModal: false,
            progress_loader: false,
            progress_opaque: false,
            leave_page_warn: false,
            org_name: 'Pronetin',
            OnboardingTutorial: true,
            OnboardingTutorial_Step: 0,
            animateSignatureToDelete: false,
            functionalTutorialRedirect: false,
            variableLimitActive: false,
        }
    }

    fetchWarningActionState = (data) => {
        this.setState({
            warning_action: {
                message: data,
            }
        })
    }

    isTemplate = (input) => {
        const regex = /^tem[a-zA-Z0-9]+$/;
        return regex.test(input);
    }

    componentDidMount() {
        this.setState({ progress_loader: true, progress_opaque: true });

        const slug = window.location.href.split('/').pop();
        if (slug === "" || slug === null) {
            window.location = "/";
        } else {
            axios.defaults.withCredentials = true;
            axios.post(this.props.node_server_axios + 'session').then((res) => {
                if (res.data !== undefined && res.data.email !== undefined && res.data.email !== '') {
                    if (res.data.user_type !== 'organisation') {
                        window.location = "/";
                    } else {
                        axios.post(this.props.node_server_axios + 'get_organisation_data', {
                            params: {
                                org_id: res.data.org_id,
                            }
                        }).then((res) => {
                            if (res.data !== undefined && res.data.message === 'success') {
                                this.setState({
                                    org_name: res.data.org_name,
                                });
                            } else {
                                window.location = "/";
                            }
                        })
                        this.setState({ email: res.data.email, loading: false, user_id: res.data.user_id, header_user_data: res.data });
                        const email = res.data.email;
                        if (slug === undefined || slug === null || slug === 'issue' || slug === 'new') {
                            if (slug === 'new') {
                                this.setState({
                                    functionalTutorialRedirect: true,
                                })
                            }
                            axios.post(this.props.node_server_axios + 'get_draft', {
                                params: {
                                    email: res.data.email,
                                },
                            }).then(async (res) => {
                                if (res.data !== undefined) {
                                    if (res.data.message === 'draft') {
                                        let cElements = res.data.elements;
                                        if (cElements === null) {
                                            cElements = JSON.stringify([{ "type": "variable", "fontSize": "24", "fontFamily": "Open Sans, sans-serif", "fontColor": "#207de9", "fontWeight": true, "fontStyle": false, "textDecorationLine": false, "lineHeight": "1", "textAlign": "center", "dataType": "textarea", "content": "[Recepient Name]", "required": true, "readOnly": true, "placeholder": "Recepient Name", "elHeight": 44, "elWidth": 298, "x": 303, "y": 299, "zIndex": 1, "timeStamp": 1700477961684 }, { "type": "required", "fontSize": "31", "fontFamily": "Nunito Sans, sans-serif", "fontColor": "#157EFB", "fontWeight": true, "fontStyle": false, "textDecorationLine": false, "lineHeight": "1", "textAlign": "center", "dataType": "textarea", "content": "CERTIFICATE\nOF APPRECIATION", "required": true, "readOnly": false, "placeholder": "Certificate Title", "elHeight": 76, "elWidth": 326, "x": 290, "y": 133, "zIndex": 1, "rows": false, "timeStamp": 1700477961685 }, { "type": "paragraph", "fontSize": 16, "fontFamily": "Arimo, sans-serif", "fontColor": "#000", "fontWeight": false, "fontStyle": false, "textDecorationLine": false, "lineHeight": "1", "textAlign": "center", "dataType": "textarea", "content": "We are honored to present [Name/Organization] with this certificate as a symbol of our appreciation for their invaluable work and contributions to [Cause/Community/Organisation] on [Date].", "required": false, "readOnly": false, "placeholder": "Enter a paragraph here...", "elHeight": 91, "elWidth": 383, "x": 260, "y": 365, "span": false, "rows": false, "timeStamp": 1700477961686 }, { "type": "textField", "fontSize": "16", "fontFamily": "Nunito Sans, sans-serif", "fontColor": "#000000", "fontWeight": false, "fontStyle": false, "textDecorationLine": false, "lineHeight": "1", "textAlign": "center", "dataType": "textarea", "content": "THIS CERTIFICATE IS AWARDED TO", "required": false, "readOnly": false, "placeholder": "Type your text here...", "elHeight": 30, "elWidth": 300, "x": 302, "y": 239, "rows": false, "timeStamp": 1700477961687 }, { "type": "signature", "signee_email": "help@pronetin.com", "signee_designation": "Help, Pronetin", "required": false, "readOnly": false, "resize": "none", "resizeLock": false, "placeholder": "Type here...", "x": 382, "y": 479, "zIndex": 3, "content": "help@pronetin.com|Help, Pronetin", "elHeight": 79, "elWidth": 140, "timeStamp": 1700477961688 }]);
                                        }
                                        let colorData = null;
                                        const img = new Image();

                                        const imgPromise = new Promise((resolve, reject) => {
                                            img.onload = resolve;
                                            img.onerror = reject;
                                        });

                                        let CTemplate = res.data.draft_bg !== null ? res.data.draft_bg : 'tem0'
                                        if (CTemplate.includes("_")) {
                                            img.src = 'https://pronetin-new.s3.ap-south-1.amazonaws.com/templates/ai/background/' + CTemplate + '.png';
                                        } else {
                                            img.src = 'https://pronetin-new.s3.ap-south-1.amazonaws.com/templates/certificates/background/' + CTemplate + '.png';

                                            const response = await axios.post(this.props.node_server_axios + 'get_cert_elements', {
                                                params: {
                                                    id: CTemplate,
                                                },
                                            });

                                            colorData = response.data.colors;
                                        }

                                        try {
                                            await imgPromise;
                                            let cWidth = 904;
                                            let cHeight = 640;

                                            if (img.naturalWidth > img.naturalHeight) {
                                                cWidth = 904;
                                                cHeight = 640;
                                            } else if (img.naturalWidth < img.naturalHeight) {
                                                cWidth = 640;
                                                cHeight = 904;
                                            } else {
                                                console.log("Invalid Size");
                                            }
                                            if (JSON.parse(cElements) !== null) {
                                                const updatedData = await Promise.all(JSON.parse(cElements).map(async (element) => {
                                                    if (element.type === 'image' && element.content !== 'shape') {
                                                        const response = await fetch("https://pronetin-new.s3.amazonaws.com/draft/" + encodeURIComponent(email) + "/" + encodeURIComponent(element.timeStamp + ".png"));
                                                        const data = await response.arrayBuffer();
                                                        return new Promise((resolve, reject) => {
                                                            let reader = new FileReader();
                                                            reader.readAsDataURL(new Blob([data]));
                                                            reader.onloadend = () => {
                                                                let base64data = reader.result;
                                                                resolve({ ...element, content: base64data });
                                                            }
                                                        });
                                                    } else {
                                                        return element;
                                                    }
                                                }));
                                                this.setState({
                                                    certTemplate: res.data.draft_bg !== null ? res.data.draft_bg : 'tem0',
                                                    certWidth: cWidth,
                                                    certHeight: cHeight,
                                                    colors: colorData,
                                                    progress_loader: false,
                                                    elementsIndex: updatedData.filter(element => element.type !== "image").map(element => ({ timeStamp: element.timeStamp, type: element.type, required: element.required, readOnly: element.readOnly, content: element.content })),
                                                    elements: updatedData,
                                                })
                                            } else {
                                                this.setState({
                                                    progress_loader: false,
                                                })
                                            }
                                        } catch (error) {
                                            console.log("Error loading image:", error);
                                        }
                                    }
                                }
                            })
                            axios.post(this.props.node_server_axios + 'get_saved_templates', {
                                params: {
                                    email: res.data.email,
                                },
                            }).then(async (res) => {
                                if (res.data !== undefined) {
                                    if (res.data.message === 'saved templates') {
                                        this.setState({
                                            savedTemplates: res.data.saved_templates,
                                        })
                                    }
                                }
                            })
                        } else if (this.isTemplate(slug)) {
                            this.handleTemplate(slug);
                            this.setState({
                                certTemplate: slug,
                            })
                        } else {
                            window.location = "/";
                        }
                    }
                } else {
                    window.location = "/signin";
                }
            }).catch(() => {
                window.location = "/signin";
            })
        }

        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleLeavePageWarn = (value) => {
        if (value === false) {
            this.setState({
                leave_page_warn: false,
            })
        }
    }

    handleBeforeUnload = (e) => {
        if (this.state.leave_page_warn) {
            e.preventDefault();
            e.returnValue = '';
            const confirmationMessage = 'Are you sure you want to leave this page?';
            return confirmationMessage;
        }
    };

    updateSavedTemplateCount = () => {
        axios.post(this.props.node_server_axios + 'get_saved_templates', {
            params: {
                email: this.state.email,
            },
        }).then(async (res) => {
            if (res.data !== undefined) {
                if (res.data.message === 'saved templates') {
                    this.setState({
                        savedTemplates: res.data.saved_templates,
                    })
                }
            }
        })
    }

    handleSendToParent = (values) => {
        this.setState({
            toAdd: values,
        })
    }

    handleCsvToParent = (values) => {
        this.setState({
            csvData: values,
            updateCsv: Math.floor(Math.random() * (999 - 100 + 1) + 100),
            leave_page_warn: true,
        })
    }

    handleCsvRowToParent = (values) => {
        this.setState(prevState => ({
            csvData: prevState.csvData.concat(values),
            leave_page_warn: true,
        }));
    }

    handleCsvRowFromParent = (id) => {
        const newArray = [...this.state.csvData];
        newArray.splice(id, 1);
        this.setState({
            csvData: newArray,
            leave_page_warn: newArray.length > 0 ? true : false,
        });
    }

    handleClearCsv = () => {
        this.setState({
            csvData: [],
            leave_page_warn: false,
        })
    }

    handlePdfToParent = (values) => {
        if (this.state.toPdf.pdf !== values.pdf) {
            this.setState({
                toPdf: values,
            })
        }
    }

    handleElementIndex = (values) => {
        this.setState({
            elementsIndex: values,
            elementToDelete: false,
        })
    }

    handleVariableIndex = (values) => {
        this.setState({
            variableIndex: values,
            variableLimitActive: this.countVariables() < 15 ? false : true,
        })
    }

    countVariables = () => {
        const { variableIndex } = this.state;
        const totalCount = variableIndex.reduce((count, item) => {
            if (item.variables && Array.isArray(item.variables)) {
                count += item.variables.filter((variable) => variable !== null).length;
            }
            return count;
        }, 0);
        return totalCount;
    };

    handleStageSelect = async (values) => {
        //Editor Tutorial
        if (values === '1') {
            this.setState({
                OnboardingTutorial_Step: 2
            })
        }
        if (values === '2') {
            // console.log(this.state.OnboardingTutorial_Step);
            if (this.state.OnboardingTutorial_Step < 4 || this.state.OnboardingTutorial_Step > 14) {
                this.setState({
                    OnboardingTutorial_Step: 4
                })
            }
        }
        if (values === '3') {
            this.setState({
                OnboardingTutorial_Step: 15
            })
        }
        if (values === '5') {
            this.setState({
                OnboardingTutorial_Step: 18
            })
        }
        if (values === '6') {
            this.setState({
                OnboardingTutorial_Step: 21
            })
        }
        if (values === 'eventModal') {
            this.setState({
                OnboardingTutorial_Step: 25
            })
            return null;
        }
        if (values === '6') {
            const containsSampleSignature = this.state.elementsIndex.some(element => element.content === 'help@pronetin.com|Help, Pronetin');
            if (containsSampleSignature) {
                //--------------------------Warning Action Trigger Start------------------------------
                let proceed_function = true;
                this.setState({
                    warning_action: {
                        message: "Placeholder Signature Found",
                        subtext: "Please remove/delete the sample placeholder signature element. You may add your desired signatures by adding the signing authorities (Optional)",
                        type: "success",
                        proceed_action: "true",
                        proceed_function: proceed_function,
                        back_action: false,
                        close: false,
                    }
                })
                if (proceed_function) {
                    await new Promise((resolve) => {
                        this.resumeFunction = resolve;
                    });
                    this.setState({
                        warning_action: {
                            message: "",
                            subtext: "",
                            type: "warning",
                            proceed_action: false,
                            proceed_function: false,
                            back_action: false,
                            close: true,
                        },
                    })
                }
                //--------------------------Warning Action Trigger End------------------------------
                this.setState({
                    step_selection: '5',
                    animateSignatureToDelete: true,
                    //Editor Tutorial
                    OnboardingTutorial_Step: 19
                })
                return null;
            }
            const containsEmptyValidity = this.state.elementsIndex.some(element => { return element.type === 'validity' && element.content === '' });
            if (containsEmptyValidity) {
                //--------------------------Warning Action Trigger Start------------------------------
                let proceed_function = true;
                this.setState({
                    warning_action: {
                        message: "Validity is Empty",
                        subtext: "Please select a valid date for validity in certificate editor or remove the element",
                        proceed_action: "true",
                        proceed_function: proceed_function,
                        back_action: false,
                        close: false,
                    }
                })
                if (proceed_function) {
                    await new Promise((resolve) => {
                        this.resumeFunction = resolve;
                    });
                    this.setState({
                        warning_action: {
                            message: "",
                            subtext: "",
                            type: "warning",
                            proceed_action: false,
                            proceed_function: false,
                            back_action: false,
                            close: true,
                        },
                    })
                }
                //--------------------------Warning Action Trigger End------------------------------
                this.setState({ step_selection: '2' })
                return null;
            }
        }
        if (values !== '6' && this.state.step_selection === '6') {
            //--------------------------Warning Action Trigger Start------------------------------
            let proceed_function = true;
            this.setState({
                warning_action: {
                    message: "Return to Editor.",
                    subtext: "Recipient details entered can be lost. You may copy and save the content.",
                    type: "warning",
                    proceed_action: "true",
                    proceed_function: proceed_function,
                    back_action: false,
                    close: true,
                }
            })
            if (proceed_function) {
                await new Promise((resolve) => {
                    this.resumeFunction = resolve;
                });
                this.setState({
                    warning_action: {
                        message: "",
                        subtext: "",
                        type: "warning",
                        proceed_action: false,
                        proceed_function: false,
                        back_action: false,
                        close: true,
                    },
                })
            }
            //--------------------------Warning Action Trigger End------------------------------
        }
        this.setState({ step_selection: values })
    }

    handleTemplate = async (values) => {

        function areArraysEqual(array1, array2) {
            if (array1.length !== array2.length) {
                return false;
            }
            const sortedArray1 = array1.sort();
            const sortedArray2 = array2.sort();
            for (let i = 0; i < sortedArray1.length; i++) {
                const obj1 = sortedArray1[i];
                const obj2 = sortedArray2[i];
                const string1 = JSON.stringify(obj1);
                const string2 = JSON.stringify(obj2);
                if (string1 !== string2) {
                    return false;
                }
            }
            return true;
        }


        let contentIndex = false;
        let titleExtracted = "CERTIFICATE\nOF APPRECIATION";
        if (values.includes("|")) {
            titleExtracted = values.split("|")[2] !== "" ? values.split("|")[2] : "CERTIFICATE\nOF APPRECIATION";
            contentIndex = values.split("|")[1];
            values = values.split("|")[0];
        }

        //logic for detecting if switched from landscape to portrait and vice versa
        let layout_chang_prompt = false;
        let layout_change_detector = this.state.certTemplate.charAt(this.state.certTemplate.length - 1).concat(values.charAt(values.length - 1))
        if ((layout_change_detector.split('p').length - 1) === 1) {
            layout_chang_prompt = true;
            //--------------------------Warning Action Trigger Start------------------------------
            let proceed_function = true;
            this.setState({
                warning_action: {
                    message: "Changing Templates",
                    subtext: "Your Current content and its position will be lost. Do you want to Continue?",
                    type: "warning",
                    proceed_action: "true",
                    proceed_function: proceed_function,
                    back_action: false,
                    close: true,
                }
            })
            if (proceed_function) {
                await new Promise((resolve) => {
                    this.resumeFunction = resolve;
                });
                this.setState({
                    warning_action: {
                        message: "",
                        subtext: "",
                        type: "warning",
                        proceed_action: false,
                        proceed_function: false,
                        back_action: false,
                        close: true,
                    },
                })
            }
            //--------------------------Warning Action Trigger End------------------------------
        }

        this.setState({
            certTemplate: values,
            toAdd: {
                type: false,
                timeStamp: false,
            }
        })

        const img = new Image();

        const imgPromise = new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
        });

        if (values.includes("_")) {
            img.src = 'https://pronetin-new.s3.ap-south-1.amazonaws.com/templates/ai/background/' + values + '.png';
        } else {
            img.src = 'https://pronetin-new.s3.ap-south-1.amazonaws.com/templates/certificates/background/' + values + '.png';
        }

        try {
            await imgPromise;
            let cWidth = 904;
            let cHeight = 640;

            if (img.naturalWidth > img.naturalHeight) {
                cWidth = 904;
                cHeight = 640;
            } else if (img.naturalWidth < img.naturalHeight) {
                cWidth = 640;
                cHeight = 904;
            } else {
                console.log("Invalid Size");
            }

            const response = await axios.post(this.props.node_server_axios + 'get_cert_elements', {
                params: {
                    id: values.includes("_") ? values.split("_")[0] : values,
                },
            });

            if (response.data.elements !== null) {
                //If you want to remove the popup box when switching through portrait templates, remove timestamp from elements in database
                if (!areArraysEqual(response.data.elements.map(obj => ({ ...JSON.parse(obj) })), this.state.elements.map(obj => { const { timeStamp, ...rest } = obj; return rest; })) && this.state.elements.length > 2) {
                    //An else logic for the below if can be used to retain positions of content while switching layout (UGLY) issue #130
                    if (!layout_chang_prompt) {
                        //--------------------------Warning Action Trigger Start------------------------------
                        let proceed_function = true;
                        this.setState({
                            warning_action: {
                                message: "Changing Templates",
                                subtext: "Your Current content and its position will be lost. Do you want to Continue?",
                                type: "warning",
                                proceed_action: "true",
                                proceed_function: proceed_function,
                                back_action: false,
                                close: true,
                                cancel_btn_text: "Change Background",
                            }
                        })
                        if (proceed_function) {
                            await new Promise((resolve) => {
                                this.resumeFunction = resolve;
                            });
                            this.setState({
                                warning_action: {
                                    message: "",
                                    subtext: "",
                                    type: "warning",
                                    proceed_action: false,
                                    proceed_function: false,
                                    back_action: false,
                                    close: true,
                                    cancel_btn_text: false,
                                },
                            })
                        }
                        //--------------------------Warning Action Trigger End------------------------------
                    }
                }
                let initTimeStamp = 0;
                let parsedData = response.data.elements.map((obj) => {
                    const updatedObj = {
                        ...JSON.parse(obj),
                        timeStamp: Date.now() + initTimeStamp++
                    };
                    if (JSON.parse(obj).type === "required") {
                        updatedObj.content = titleExtracted.toUpperCase();
                    }
                    return updatedObj;
                });

                let colorData = response.data.colors;

                if (contentIndex !== false && values.includes("_")) {
                    axios.defaults.withCredentials = true;
                    await axios.post(this.props.node_server_axios + 'get_tag_data_ai', {
                        params: {
                            id: contentIndex,
                        },
                    }).then(async (res) => {
                        if (res.data !== undefined) {
                            if (res.data.message === 'tag data') {
                                let contentData = JSON.parse(`[${res.data.tagDataDefault}]`);
                                let randomIndex = Math.floor(Math.random() * contentData.length);
                                parsedData = parsedData.map(obj => {
                                    if (obj.type === "paragraph") {
                                        return {
                                            ...obj,
                                            content: contentData[randomIndex].body,
                                        };
                                    } else if (obj.type === "textField") {
                                        return {
                                            ...obj,
                                            content: contentData[randomIndex].header,
                                        };
                                    } else if (obj.type === "required") {
                                        return {
                                            ...obj,
                                            content: titleExtracted.toUpperCase(),
                                        };
                                    }
                                    return obj;
                                });
                                this.setState({
                                    elements: parsedData,
                                    colors: colorData,
                                    certWidth: cWidth,
                                    certHeight: cHeight,
                                    generative: true,
                                });
                            } else {
                                this.setState({
                                    elements: parsedData,
                                    colors: colorData,
                                    certWidth: cWidth,
                                    certHeight: cHeight,
                                    generative: false,
                                });
                            }
                        }
                    })
                } else {
                    this.setState({
                        elements: parsedData,
                        colors: colorData,
                        certWidth: cWidth,
                        certHeight: cHeight,
                        generative: false,
                        progress_loader: false,
                    });
                }
            } else {
                this.setState({
                    certWidth: cWidth,
                    certHeight: cHeight,
                    generative: false,
                });
            }
        } catch (error) {
            console.log("Error loading image:", error);
        }
    }

    handleElementToDelete = (values) => {
        this.setState({
            elementToDelete: values,
        });
    }

    exitFromCurrentEditor = async (location) => {
        //--------------------------Warning Action Trigger Start------------------------------
        let proceed_function = true;
        this.setState({
            warning_action: {
                message: "Leaving this Editor",
                subtext: "Documents attached and recipient details will be lost. Do you wish to continue?",
                type: "warning",
                proceed_action: "true",
                proceed_function: proceed_function,
                back_action: false,
                close: true,
            }
        })
        if (proceed_function) {
            await new Promise((resolve) => {
                this.resumeFunction = resolve;
            });
            this.setState({
                warning_action: {
                    message: "",
                    subtext: "",
                    type: "warning",
                    proceed_action: false,
                    proceed_function: false,
                    back_action: false,
                    close: true,
                },
            })
        }
        //--------------------------Warning Action Trigger End------------------------------
        window.location.href = "/" + location;
    }

    closeSaveListModal = (e) => {
        if (e.target.className === 'editor-switch-save-modal') {
            this.setState({
                saveListModal: false,
            });
        }
    }

    openSaveListModal = () => {
        this.setState({
            saveListModal: true,
        });
    }

    handleChildElements = (values) => {
        this.setState({
            elements: values,
        });
    }

    toggleOnboarding = (value) => {
        this.setState({ OnboardingTutorial: value });
    }

    OnboardingTutorial_Step = (value) => {
        this.setState({ OnboardingTutorial_Step: value });
    }

    stepSelection = (value) => {
        if (value > 0) {
            this.setState({ step_selection: value });
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <React.Fragment>
                    <div className="main">
                        <Header />
                        <Loading />
                    </div>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    <div className="main issue-page">
                        <Header login={true} user_data={this.state.header_user_data} email={this.state.email} node_server_axios={this.props.node_server_axios} />
                        <div className='editor-switch'>
                            <button onClick={() => this.exitFromCurrentEditor('issue')} className='active'>My Draft</button>
                            <button onClick={this.openSaveListModal}>Saved Designs</button>
                        </div>
                        {this.state.saveListModal && (
                            <div className='editor-switch-save-modal' onClick={this.closeSaveListModal}>
                                <div className='container'>
                                    <h2><i className="fa-regular fa-floppy-disk"></i> Choose Saved Template</h2>
                                    {this.state.savedTemplates !== null && this.state.savedTemplates.length > 0 ?
                                        this.state.savedTemplates.map((element, index) =>
                                            <div className='saved-tile' key={index} onClick={() => this.exitFromCurrentEditor('edit/' + element.save_id)}>
                                                <img src={element.draft_bg.includes("_") ? 'https://pronetin-new.s3.ap-south-1.amazonaws.com/templates/ai/background/' + element.draft_bg + '.png' : 'https://pronetin-new.s3.ap-south-1.amazonaws.com/templates/certificates/background/' + element.draft_bg + '.png'} alt='certificate template'></img>
                                                <button><i className="fa-regular fa-edit"></i> Edit</button>
                                            </div>
                                        )
                                        :
                                        <p>No saved Templates</p>
                                    }
                                </div>
                            </div>
                        )}
                        <div className='editor-wrapper'>
                            <IssueSideNav fetchChildState={this.handleSendToParent} fetchChildStageSelect={this.handleStageSelect} step_selection={this.state.step_selection} elementIndex={this.state.elementsIndex} variableIndex={this.state.variableIndex} fetchPdfState={this.handlePdfToParent} fetchTemplate={this.handleTemplate} email={this.state.email} fetchCsvState={this.handleCsvToParent} node_server_axios={this.props.node_server_axios} user_id={this.state.user_id} fetchElementToDelete={this.handleElementToDelete} org_name={this.state.org_name} OnboardingTutorial_Step={this.OnboardingTutorial_Step} animateSignatureToDelete={this.state.animateSignatureToDelete} />
                            <IssueElement toAdd={this.state.toAdd} fetchChildStageSelect={this.handleStageSelect} step_selection={this.state.step_selection} fetchChildElements={this.handleChildElements} fetchChildElementIndex={this.handleElementIndex} fetchInlineVariableIndex={this.handleVariableIndex} pdf={this.state.toPdf} certTemplate={this.state.certTemplate} email={this.state.email} addRecepient={this.state.csvData} updateCsv={this.state.updateCsv} addRowCsv={this.handleCsvRowToParent} removeRowCsv={this.handleCsvRowFromParent} clearCsv={this.handleClearCsv} node_server_axios={this.props.node_server_axios} elements={this.state.elements} certWidth={this.state.certWidth} certHeight={this.state.certHeight} fetchChildState={this.handleSendToParent} generative={this.state.generative} colors={this.state.colors} elementToDelete={this.state.elementToDelete} savedTemplateCount={this.state.savedTemplates.length} updateSavedTemplateCount={this.updateSavedTemplateCount} leavePageWarn={this.handleLeavePageWarn} OnboardingTutorial_Step={this.OnboardingTutorial_Step} fetchPdfState={this.handlePdfToParent} variableLimitActive={this.state.variableLimitActive} />
                            {
                                this.state.warning_action.message !== "" ? <WarningAction data={this.state.warning_action} fetchWarningActionState={this.fetchWarningActionState} resumeFunction={this.resumeFunction} /> : ""
                            }
                        </div>
                        <div className='editor-nosupport center'>
                            <i className="fa-solid fa-desktop"></i>
                            <p>Signin using PC / Larger Display</p>
                            <button onClick={() => { window.location = './' }}><i className="fa-solid fa-arrow-left"></i> Back</button>
                        </div>
                        <div className='editor-nosupport'>
                            <i className="fa-solid fa-mobile-screen-button"></i>
                            <h2>Editor not supported in this resolution ({window.innerWidth + "x" + window.innerHeight})</h2>
                            <p>Please login your account in a larger display to access editor</p>
                        </div>
                    </div>
                    {
                        this.state.progress_loader && (<ProgressLoader opaque={this.state.progress_opaque} />)
                    }
                    {!localStorage.getItem('onboarding_editor') && this.state.OnboardingTutorial && !this.state.progress_loader && (
                        <OnboardingTutorial toggleOnboarding={this.toggleOnboarding} goToStep={this.state.OnboardingTutorial_Step} step_selection={this.stepSelection} functionalTutorialRedirect={this.state.functionalTutorialRedirect} />
                    )}
                </React.Fragment>
            )
        }
    }
}
export default Issue;